var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhyRak3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.792,
    height: 47,
    viewBox: "0 0 54.792 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-bag-7749863",
    transform: "translate(-12.672 -17.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14891",
    "data-name": "Path 14891",
    d: "M15.608,44.115a27.183,27.183,0,0,1-2.738-9.047c-.009-.052-.014-.155-.037-.287a6.052,6.052,0,0,0-.161,1.379V63.578a5.879,5.879,0,0,0,5.871,5.871h3.171V52.1a27.276,27.276,0,0,1-6.106-7.984Z",
    transform: "translate(0 -4.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14892",
    "data-name": "Path 14892",
    d: "M83.89,34.781c-.014.089-.023.175-.029.258A27.288,27.288,0,0,1,75.011,52.1V69.451h3.171a5.879,5.879,0,0,0,5.871-5.871V36.163a6.033,6.033,0,0,0-.161-1.379Z",
    transform: "translate(-16.589 -4.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14893",
    "data-name": "Path 14893",
    d: "M44.408,66.267a27.352,27.352,0,0,1-15.42-4.747V76.564H59.826V61.519a27.352,27.352,0,0,1-15.42,4.747Z",
    transform: "translate(-4.342 -11.586)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14894",
    "data-name": "Path 14894",
    d: "M62.639,25.818H51.757V23.851a5.879,5.879,0,0,0-5.871-5.871H36.345a5.879,5.879,0,0,0-5.871,5.871v1.967H19.592a5.863,5.863,0,0,0-2.979.814,31.065,31.065,0,0,0,.221,3.6l.043.33a24.462,24.462,0,0,0,48.482,0c.014-.1.029-.212.043-.324.126-1.158.221-2.46.272-3.581a5.842,5.842,0,0,0-3.03-.843Zm-13.818,0H33.41V23.851a2.939,2.939,0,0,1,2.936-2.936h9.541a2.939,2.939,0,0,1,2.936,2.936Z",
    transform: "translate(-1.049)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhyRak3);
export default __webpack_public_path__ + "static/media/icon-why-rak-3.f0f9057232341b348150679b356e745a.svg";
export { ForwardRef as ReactComponent };